<!--航线列表-->
<template>
  <div class="project-wayline-wrapper height-100">
    <a-spin :spinning="loading" :delay="300" tip="downloading" size="large">
      <div ref="heightRef" class="way-head">
        <a-row>
          <a-col :span="1"></a-col>
          <a-col :span="15">航线</a-col>
          <a-col :span="7" v-if="importVisible" class="flex-row flex-justify-end flex-align-center">
            <!-- <a-upload v-hasPermi="['wayline:import']" name="file" :multiple="false" :before-upload="beforeUpload" :show-upload-list="false" :customRequest="uploadFile" >
              <a-button type="text" class="color-white">
                <a-tooltip title="上传航线" placement="right">
                  <SelectOutlined />
                </a-tooltip>
              </a-button>
            </a-upload> -->
            <a-tooltip title="上传航线" placement="right" v-if="auth.hasPermi(['wayline:import'])">
              <SelectOutlined @click="openuploadWaylineVisible"/>
            </a-tooltip>
          </a-col>
        </a-row>
        <div class="select-header">
          <div>
            <a-select v-model:value="waylineType" class="select-type">
              <a-select-option value="allType">所有类型</a-select-option>
              <a-select-option v-for="item in waylineAttribute" :key="item.dictValue" :value="item.dictValue" >{{ item.dictLabel }}类型</a-select-option>
            </a-select>
            <a-select v-model:value="wayline" class="select-type ml5">
              <a-select-option value="allWayline">所有航线</a-select-option>
              <a-select-option value="associated">关联机场航线</a-select-option>
              <a-select-option value="NotAssociated">未关联机场航线</a-select-option>
            </a-select>
            <a-button type="primary" size="middle" @click="openModal" class="add ml5" v-hasPermi="['wayline:add']"><PlusOutlined />添加航线</a-button>
          </div>
          <div class="wayline-icon-list">
            <a-tooltip placement="bottom" :key="item" v-for="(item, index) in TEMPLATE_TYPE" :title="TEMPLATE_TYPE_NAME[index]">
            <div class="wayline-icon-item" @click="handleClickType(index)" :class="{ active: templateType.includes(index) }" >
              <i :class="`iconfont ${TEMPLATE_TYPE_ICON[index]}`"></i>
            </div>
            </a-tooltip>
          </div>
        </div>
      </div>

      <div class="wayline-content-container">
        <div class="folder-list-container">
          <div class="folder-list">
            <div class="folder-header">
              文件夹
              <a-tooltip title="添加文件夹" v-if="auth.hasPermi(['wayline:folder:add'])" v-hasPermi="['wayline:folder:add']">
                <FolderAddOutlined class="add-folder" @click="showAddFolderInput" />
              </a-tooltip>
            </div>
            <div v-if="showFolderInput" class="folder-input-container">
              <a-input v-model:value="newFolderName" :placeholder="editingFolderId ? '请输入新的文件夹名称' : '请输入文件夹名称'"
                size="small" @pressEnter="createOrUpdateFolder" class="folder-input" />
              <CheckOutlined class="ml5 cur-p" :style="{ color: 'green' }" @click.stop="createOrUpdateFolder" />
              <CloseOutlined class="ml5 cur-p" :style="{ color: 'red' }" @click.stop="cancelCreateFolder" />
            </div>
            <!-- <div class="folder-content">
              <div
                class="folder-item"
                :class="{ 'folder-active': activeFolderId === '' }"
                @click="selectFolder('')"
              >
                <div class="folder-item-left">
                  <FolderOutlined class="mr5 fz16" />全部航线
                </div>
              </div>
              <div
                v-for="folder in waylineFolders"
                :key="folder.id"
                :value="folder.id"
                class="folder-item"
                :class="{ 'folder-active': activeFolderId === folder.id }"
                @click="selectFolder(folder.id)"
              >
                <div class="folder-item-left" :title="folder.name">
                  <FolderOutlined class="mr5 fz16" />
                  <span
                    v-if="editingFolderId !== folder.id"
                    class="folder-name-text" :title="folder.name"
                    >{{ folder.name }}</span
                  >
                  <a-input
                    v-else
                    v-model:value="newFolderName"
                    size="small"
                    @pressEnter="createOrUpdateFolder"
                    @blur="createOrUpdateFolder"
                    :ref="(el) => (inlineFolderInputRef = el)"
                    class="inline-folder-input"
                  />
                </div>
                <a-tooltip title="添加文件夹" v-hasPermi="['wayline:folder:add']">
                  <FolderAddOutlined
                    class="add-folder"
                    @click="showAddNextFolderInput(folder)"
                  />
                </a-tooltip>
                <a-tooltip
                  title="编辑"
                  v-if="editingFolderId !== folder.id"
                  v-hasPermi="['wayline:folder:edit']"
                >
                  <EditOutlined
                    class="folder-add-icon"
                    @click.stop="editWaylineFolder(folder)"
                  />
                </a-tooltip>
                <template v-else>
                  <a-tooltip title="确认" v-hasPermi="['wayline:folder:edit']">
                    <CheckOutlined
                      class="folder-add-icon"
                      :style="{ color: 'green' }"
                      @click.stop="createOrUpdateFolder"
                    />
                  </a-tooltip>
                  <a-tooltip title="取消" v-hasPermi="['wayline:folder:edit']">
                    <CloseOutlined
                      class="folder-add-icon"
                      :style="{ color: 'red' }"
                      @click.stop="cancelEditFolder"
                    />
                  </a-tooltip>
                </template>
                <a-tooltip
                  title="删除"
                  v-if="folder.wayline_count === 0"
                  v-hasPermi="['wayline:folder:remove']"
                >
                  <DeleteOutlined
                    class="folder-add-icon"
                    @click.stop="showDeleteFolderTip(folder.id)"
                  />
                </a-tooltip>
                <a-tooltip
                  v-hasPermi="['wayline:folder:add']"
                  title="添加航线"
                  @click.stop="openAddWaylineToFolder(folder.id)"
                >
                  <PlusOutlined class="folder-add-icon" />
                </a-tooltip>
              </div>
              <div v-if="waylineFolders.length === 0" class="empty-folder">
                <a-empty
                  :image-style="{ height: '40px' }"
                  description="暂无文件夹"
                />
              </div>
            </div> -->

            <div class="folder-content">
              <div class="folder-item" :class="{ 'folder-active': activeFolderId === '' }" @click="selectFolder('')" >
                <div class="folder-item-left">
                  <FolderOutlined class="mr5 fz16" />全部航线
                </div>
              </div>

              <a-tree :tree-data="treeData" :expanded-keys="expandedKeys" :show-icon="false" :block-node="true" @update:expanded-keys="(keys) => expandedKeys = keys"
                @select="handleTreeSelect" class="folder-tree" >
              <template #title="nodeProps">
                <div class="folder-item" :class="{ 'folder-active': activeFolderId === nodeProps.dataRef.id }">
                  <!-- <a-badge :count="nodeProps.dataRef.wayline_count || 0" class="folder-badge" /> -->
                  <div class="folder-item-left" @click.stop="selectFolder(nodeProps.dataRef.id)">
                    <FolderOutlined class="mr5 fz16" />
                    <a-input v-if="editingFolderId === nodeProps.dataRef.id" v-model:value="newFolderName" size="small" @pressEnter="createOrUpdateFolder"
                      :ref="(el) => (inlineFolderInputRef = el)" class="inline-folder-input" />
                    <span v-else class="folder-name-text" :title="nodeProps.dataRef.name">
                      {{ nodeProps.dataRef.name }}
                    </span>
                  </div>
                  <div class="folder-actions">
                    <a-tooltip title="编辑" v-if="editingFolderId !== nodeProps.dataRef.id && auth.hasPermi(['wayline:folder:edit'])" v-hasPermi="['wayline:folder:edit']">
                      <EditOutlined class="folder-add-icon" @click.stop="editWaylineFolder(nodeProps.dataRef)" />
                    </a-tooltip>
                    <template v-else>
                      <a-tooltip title="确认" v-if="auth.hasPermi(['wayline:folder:edit'])" v-hasPermi="['wayline:folder:edit']">
                        <CheckOutlined class="folder-add-icon" style="color: green" @click.stop="createOrUpdateFolder" />
                      </a-tooltip>
                      <a-tooltip title="取消" v-if="auth.hasPermi(['wayline:folder:edit'])" v-hasPermi="['wayline:folder:edit']">
                        <CloseOutlined class="folder-add-icon" style="color: red" @click.stop="cancelEditFolder" />
                      </a-tooltip>
                    </template>
                    <a-tooltip title="删除" v-hasPermi="['wayline:folder:remove']"
                      v-if="auth.hasPermi(['wayline:folder:remove']) && nodeProps.dataRef.wayline_count === 0 && (!nodeProps.dataRef.children || nodeProps.dataRef.children.length === 0) && editingFolderId !== nodeProps.dataRef.id">
                      <DeleteOutlined class="folder-add-icon" @click.stop="showDeleteFolderTip(nodeProps.dataRef.id)" />
                    </a-tooltip>
                    <a-dropdown v-if="auth.hasPermi(['wayline:folder:more'])" v-hasPermi="['wayline:folder:more']">
                      <DashOutlined class="folder-add-icon" />
                      <template #overlay>
                        <a-menu>
                          <a-menu-item @click.stop="openAddWaylineToFolder(nodeProps.dataRef.id)"  v-if="auth.hasPermi(['wayline:folder:add'])">
                            <PlusOutlined class="folder-add-icon mr5" v-hasPermi="['wayline:folder:add']"/>添加航线
                          </a-menu-item>
                          <a-menu-item @click.stop="showAddChildInput(nodeProps.dataRef)"  v-if="auth.hasPermi(['wayline:folder:addChild'])">
                            <FolderAddOutlined class="folder-add-icon mr5" v-hasPermi="['wayline:folder:addChild']"/>添加子文件夹
                          </a-menu-item>
                        </a-menu>
                      </template>
                    </a-dropdown>
                  </div>
                </div>
                <div v-if="activeAddChildFolderId === nodeProps.dataRef.id" class="add-child-input">
                  <a-input v-model:value="newChildFolderName" placeholder="请输入子文件夹名称" size="small" style="width: 150px;" @pressEnter="confirmAddChild" :disabled="addChildLoading" />
                  <CheckOutlined class="ml5 cur-p" style="color: green; margin-left: 8px;" @click="confirmAddChild" />
                  <CloseOutlined class="ml5 cur-p" style="color: red;" @click="cancelAddChild" />
                </div>
              </template>
            </a-tree>
            <div v-if="waylineFolders.length === 0" class="empty-folder">
              <a-empty :image-style="{ height: '40px' }" description="暂无文件夹" />
            </div>
          </div>
        </div>
      </div>
      <div class="wayline-list-container" ref="scrollbarRef" :style="{ height: listHeight }" >
        <div id="data" class="uranus-scrollbar" v-if="waylinesData.data.length !== 0" @scroll="onScroll" >
          <div v-for="wayline in waylinesData.data" :key="wayline.id">
            <div class="wayline-panel pt5" @click="selectRoute(wayline)">
              <div class="title">
                <a-tooltip :title="wayline.name">
                  <div class="pr10 way-name">{{ wayline.name }}</div>
                </a-tooltip>
                <div class="ml10">
                  <UserOutlined />
                </div>
                <a-tooltip :title="wayline.user_name">
                  <div class="ml5 pr10 way-user">{{ wayline.user_name }}</div>
                </a-tooltip>
                <div class="fz20 flex-row">
                  <a-button v-hasPermi="['wayline:edit']" type="text" size="small" @click.prevent.stop="handleEdit(wayline)" >
                    <template #icon><EditTwoTone /></template>
                  </a-button>
                  <a-dropdown v-if="auth.hasPermi([ 'wayline:download', 'wayline:move', 'wayline:delete'])" v-hasPermi="[ 'wayline:download', 'wayline:move', 'wayline:delete', ]" >
                    <a class="color-white">
                      <EllipsisOutlined />
                    </a>
                    <template #overlay>
                      <a-menu theme="dark" class="more way-down">
                        <a-menu-item v-hasPermi="['wayline:download']" v-if="auth.hasPermi(['wayline:download'])" @click="downloadWayline(wayline.id, wayline.name)" >
                          <span>下载</span>
                        </a-menu-item>
                        <a-menu-item v-hasPermi="['wayline:move']" v-if="auth.hasPermi(['wayline:move'])" @click="showMoveModal(wayline.id)" >
                          <span>移动</span>
                        </a-menu-item>
                        <a-menu-item v-hasPermi="['wayline:delete']" v-if="auth.hasPermi(['wayline:delete'])" @click="showWaylineTip(wayline.id)" >
                          <span>删除</span>
                        </a-menu-item>
                      </a-menu>
                    </template>
                  </a-dropdown>
                </div>
              </div>
              <div class="ml10 mt5 way-color">
                <span>巡检区域：</span>
                <span class="ml5">{{ wayline.inspection_area_name || '--' }}</span>
              </div>
              <div class="ml10 mt5 way-color">
                <span><RocketOutlined /></span>
                <span class="ml5">{{ DEVICE_NAME[wayline.drone_model_key] }}</span>
                <span class="ml10"><CameraFilled class="cam-icon" /></span>
                <span class="ml5" v-for="payload in wayline.payload_model_keys" :key="payload.id" >{{ DEVICE_NAME[payload] }}</span>
              </div>
                <div class="mt5 ml10 mr10 way-color1">
                  <span class="mr10" >更新时间
                    {{ new Date(wayline.update_time).toLocaleString() }}</span>
                  <span class="icon">
                    <a-tooltip v-if="wayline.template_types" placement="right">
                      <template #title>
                        <span>{{ TEMPLATE_TYPE_NAME[wayline.template_types[0]] }}</span>
                      </template>
                      <i :class="`iconfont ${TEMPLATE_TYPE_ICON[wayline.template_types[0]]}`"></i>
                    </a-tooltip>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <a-empty :image-style="{ height: '60px', marginTop: '60px' }" />
          </div>
        </div>
      </div>

      <a-modal v-model:visible="deleteTip" width="450px" :closable="false" :maskClosable="false" centered :okButtonProps="{ danger: true }" @ok="deleteWayline">
        <p class="pt10 pl20 height-50">航线文件一旦删除将无法恢复。是否继续?</p>
        <template #title>
          <div class="flex-row flex-justify-center">
            <span>删除</span>
          </div>
        </template>
      </a-modal>

      <a-modal v-model:visible="deleteFolderTip" width="450px" :closable="false" :maskClosable="false" centered :okButtonProps="{ danger: true }" @ok="confirmDeleteFolder" >
        <p class="pt10 pl20 height-50">是否继续删除文件夹?</p>
        <template #title>
          <div class="flex-row flex-justify-center">
            <span>删除文件夹</span>
          </div>
        </template>
      </a-modal>
    </a-spin>

    <div>
      <AddWayline ref="addWaylineRef" @save="handleSave"></AddWayline>
    </div>

    <a-modal v-model:visible="removeFileVisible" width="600px" centered :footer="null" :closable="false" :maskClosable="false">
      <template #title>
        <div class="flex-row flex-justify-center">
          <span class="fz16">移动到</span>
        </div>
      </template>
      <div class="folder-modal-container">
        <!-- 树形文件夹列表（单选） -->
        <a-tree
          :tree-data="moveTreeData"
          :expanded-keys="moveExpandedKeys"
          :checked-keys="moveCheckedKeys"
          checkable
          :check-strictly="true"
          @expand="(keys) => moveExpandedKeys = keys"
          @check="onMoveCheck"
          class="move-folder-tree"
        />
        <div v-if="waylineFolders.length === 0" class="folder-empty-modal">
          <a-empty :image-style="{ height: '40px' }" description="暂无文件夹" />
        </div>
      </div>
      <div class="folder-modal-footer">
        <a-button class="modal-cancel-btn" @click="cancelMove">取消</a-button>
        <a-button type="primary" class="modal-confirm-btn" :disabled="!selectedMoveFolderId" @click="confirmMove">移动到</a-button>
      </div>
    </a-modal>

    <a-modal v-model:visible="addFileVisible" width="600px" centered :footer="null" :maskClosable="false">
      <template #title>
        <div class="flex-row flex-justify-center">
          <span class="fz16">添加到</span>
        </div>
      </template>
      <a-table :columns="addFileColumns" :data-source="addFileData" :scroll="{ x: '100%', y: 300 }" :row-selection="rowSelection" :rowKey="(record) => record.id"></a-table>
      <div class="folder-modal-footer">
        <a-button class="modal-cancel-btn" @click="cancelAddFile">取消</a-button>
        <a-button type="primary" class="modal-confirm-btn" @click="confirmAddFile" :disabled="selectedRowKeys.length === 0" :loading="addFileLoading">确定</a-button>
      </div>
    </a-modal>

    <a-modal v-model:visible="uploadWaylineVisible" title="上传航线" width="600px" @cancel="closeUploadModal" @ok="doUploadWaylineVisible" :confirmLoading="uploadLoading">
      <a-form layout="vertical">
        <a-form-item label="选择航线文件">
          <!-- <a-upload name="file" :multiple="false" :before-upload="beforeUpload" :show-upload-list="false" :customRequest="uploadFile"> -->
          <a-upload name="file" :multiple="false" :show-upload-list="false" @change="handleFileChange">
            <a-button>
              <upload-outlined /> 选择文件
            </a-button>
          </a-upload>
          <div v-if="uploadFileName" class="mt10">{{ uploadFileName }}</div>
        </a-form-item>

        <a-form-item label="关联部门（可选）">
          <div class="dept-selector">
            <a-input v-model:value="selectedDeptNamesStr" placeholder="请选择部门" readonly class="flex1" />
            <PlusCircleTwoTone class="fz20 ml10 cur-p" @click="showDeptPanel = !showDeptPanel" />
          </div>
          <div v-if="showDeptPanel" class="dept-panel">
            <div class="dept-panel-header">
              <span>选择部门</span>
              <CloseOutlined @click="showDeptPanel = false" />
            </div>
            <div class="dept-tree-container">
              <a-tree
                v-if="deptTreeData.length"
                :tree-data="deptTreeData"
                :checked-keys="selectedDeptKeys"
                checkable
                :check-strictly="true"
                @check="onDeptCheck"
                :expanded-keys="expandedDeptKeys"
                @expand="(keys) => expandedDeptKeys = keys"
              />
              <a-empty v-else description="暂无部门数据" :image-style="{ height: '60px' }" />
            </div>
          </div>
        </a-form-item>

        <a-form-item label="巡检区域">
          <!-- <a-select v-model:value="flightAreaValue" placeholder="请选择巡检区域">
            <a-select-option v-for="item in flightData" :key="item.id" :value="item.id">{{ item.areaName }}</a-select-option>
          </a-select> -->
          <a-tree-select
            v-model:value="flightAreaValue"
            :tree-data="flightAreaTreeData"
            placeholder="请选择巡检区域"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            allow-clear
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script lang="ts" setup>
import { computed, reactive } from '@vue/reactivity'
import { message } from 'ant-design-vue'
import { nextTick, onMounted, onUnmounted, ref, watch, defineComponent, h } from 'vue'
import { checkName, deleteWaylineFile, downloadWaylineFile, getWaylineFiles, importKmzFile, lineSaveForm, saveLine, uploadReName } from '/@/api/wayline'
import { ELocalStorageKey, ERouterName } from '/@/types'
import { EllipsisOutlined, RocketOutlined, CameraFilled, UserOutlined, SelectOutlined, FolderOutlined, PlusOutlined, EditOutlined, CheckOutlined, CloseOutlined, DeleteOutlined } from '@ant-design/icons-vue'
import { DEVICE_MODEL_KEY, DEVICE_NAME, DRONE_TYPE, PAYLOAD_TRY_TYPE, DEVICE_CAMERA_LIST, DEVICE_SERVER_LIST, DEVICE_VALUES, DEVICE_CAMERA_DIR } from '/@/types/device'
import { useMyStore } from '/@/store'
import { FINISH_ACTION_TYPE, FLY_TO_WAYLINE_MODEL_TYPE, FollowType, GIMBAL_PITCH_MODE_TYPE, SHOOT_TYPE, TEMPLATE_TYPE, TEMPLATE_TYPE_ICON, TEMPLATE_TYPE_NAME, WaylineFile, WaylineMapType, WaylineSmoothType } from '/@/types/wayline'
import { downloadFile } from '/@/utils/common'
import { IPage } from '/@/api/http/type'
import { getRoot } from '/@/root'
import { useRouter } from 'vue-router'
import { drawWaylinePoint, drawWaylinePolygon, drawWaylineStrip, getCesiumDataSource, getCesiumMap, state } from '/@/hooks/Cesium'
import AddWayline from '/@/components/wayline/add.vue'
// 导入工具类
import DJIWaylineTools from '/@/utils/kmlUtil'
import { createWaylineFolder, deleteWaylineFolder, getUnboundWaylineFolderList, getUpdateWaylineFolder, getWaylineFolderList, getWaylineFolderTree } from '/@/api/waylineFolder'
import auth from '/@/plugins/auth'
import { getDictList } from '/@/api/algCode'
import { getCheckInspectionAreasList, getDeptList } from '/@/api/insp/insp-dept'

const router = useRouter()

const scrollbarRef = ref()

const heightRef = ref()

const waylineFile = ref('all')

const waylineType = ref('allType')

const wayline = ref('allWayline')
const templateType = ref<`${number}`[]>([])
const addWaylineRef = ref()
const userName = computed(() => {
  const name = localStorage.getItem(ELocalStorageKey.Username) || null
  return name
})

const handleClickType = (val:`${number}`) => {
  if (templateType.value.includes(val)) {
    templateType.value = templateType.value.filter((item) => item !== val)
  } else {
    templateType.value.push(val)
  }
  pagination.page = 1
  waylinesData.data = []
  getWaylines()
}

const openModal = () => {
  addWaylineRef.value.openModal()
}

const waylineAttribute = ref<any[]>([])

async function waylineAttList () {
  const res = await getDictList('route_attribute')
  if (res && res.code === 0) {
    waylineAttribute.value = res.data || []
  }
}

const loading = ref(false)
const store = useMyStore()
const pagination: IPage = {
  page: 1,
  total: -1,
  page_size: 10,
}

const waylinesData = reactive({
  data: [] as WaylineFile[],
})

const root = getRoot()
const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId)!
const deleteTip = ref(false)
const deleteWaylineId = ref<string>('')
const canRefresh = ref(true)
const importVisible = ref<boolean>(
  root.$router.currentRoute.value.path === '/' + ERouterName.WAYLINE,
)

// 列表高度计算
const listHeight = computed(() => {
  let height = 'calc(100vh'
  if (heightRef.value) {
    height += ` - ${heightRef.value.offsetHeight + 60}px`
  }
  height += ')'
  if (scrollbarRef.value) {
    scrollbarRef.value.style.height = height
  }
  return height
})

// 文件夹列表高度计算
const folderListHeight = computed(() => {
  return listHeight.value
})

const viewer = ref(null)
const mapDataSource = ref(null)

function handleSave (row) {
  const { form, errorForm, assAirport, videoValue, choseValue } = row
  if (!form.name) {
    errorForm.nameNone = true
    return
  }
  errorForm.nameNone = false
  errorForm.nameOr = false
  const formData = new FormData()
  formData.append('name', form.name)
  formData.append('wayline_id', form.id)
  checkName(workspaceId, formData)
    .then(async (res) => {
      const params = JSON.parse(JSON.stringify(form)) as lineSaveForm
      params.drone_type = choseValue
      params.payload_types = videoValue
      let data = DEVICE_MODEL_KEY[PAYLOAD_TRY_TYPE[videoValue]]
      params.payload_model_keys = [
        `${DEVICE_MODEL_KEY[PAYLOAD_TRY_TYPE[videoValue] + 'Camera']}`,
      ]
      if (!data) {
        const nowRow = DEVICE_SERVER_LIST.find((el) => el.value === choseValue)
        const nowIndex = DEVICE_CAMERA_LIST[choseValue].findIndex(
          (el) => el.value === videoValue,
        )
        const row = DEVICE_VALUES.find(
          (el) => el.label === nowRow?.label,
        )?.value.split(',')[nowIndex]
        data = row
        params.payload_model_keys = [
          `${DEVICE_MODEL_KEY[PAYLOAD_TRY_TYPE[videoValue].substring(PAYLOAD_TRY_TYPE[videoValue].length, PAYLOAD_TRY_TYPE[videoValue].length - 1) + 'Camera']}`,
        ]
      }
      if (assAirport) {
        params.device_sn_list = [assAirport]
      }
      params.drone_model_key = data
      params.dept_ids = form.dept_ids || ''
      params.inspection_area_id = form.inspection_area_id || null
      let payloadList = []
      if (params.drone_type === DRONE_TYPE.M30) {
        payloadList = ['wide', 'zoom']
      } else if (params.drone_type === DRONE_TYPE.M3D) {
        payloadList = ['ir']
      }
      let kml = {}
      let file = {}
      let saveFile = null
      if (params.template_types[0] === '0') {
        kml = {
          payloadLensIndex: payloadList,
          flyToWaylineMode: FLY_TO_WAYLINE_MODEL_TYPE.SAFELY,
          takeOffSecurityHeight: 20,
          heightMode: WaylineMapType.EGM96,
          globalRTHHeight: 100,
          globalHeight: 100,
          autoFlightSpeed: 10,
          waypointTurnMode:
            WaylineSmoothType.TO_POINT_AND_STOP_WITH_DISCONTINUITY_CURVATURE,
          waypointHeadingMode: FollowType.FOLLOW_WAYLINE,
          gimbalPitchMode: GIMBAL_PITCH_MODE_TYPE.MANUAL,
          finishAction: FINISH_ACTION_TYPE.GO_HOME,
        }
        if (assAirport) {
          const air = addWaylineRef.value.dockSnList.find(el => el.device_sn === assAirport)
          if (air) {
            kml.startPoint = {
              longitude: air.lon * 1,
              latitude: air.lat * 1,
              height: 0,
            }
          }
        }
        file = await DJIWaylineTools.setWaypointKml({
          ...kml,
          ...params,
          author: userName.value,
        })
        saveFile = await DJIWaylineTools.setPointDoc(file)
      } else if (params.template_types[0] === '1') {
        kml = {
          payloadLensIndex: payloadList,
          imageFormat: DEVICE_CAMERA_DIR[videoValue],
          shootType: SHOOT_TYPE.TIME,
          autoFlightSpeed: 8,
          heightMode: WaylineMapType.EGM96,
          globalHeight: 100,
          GSD: 5,
          irGSD: 5,
          orthoLidarOverlapW: 70,
          margin: 0,
          finishAction: FINISH_ACTION_TYPE.GO_HOME,
          flyToWaylineMode: FLY_TO_WAYLINE_MODEL_TYPE.SAFELY,
          takeOffSecurityHeight: 20,
          distance: 0,
          duration: 0,
          author: userName.value,
        }
        if (assAirport) {
          const air = addWaylineRef.value.dockSnList.find(el => el.device_sn === assAirport)
          if (air) {
            kml.startPoint = {
              longitude: air.lon * 1,
              latitude: air.lat * 1,
              height: 0,
            }
          }
        }
        file = DJIWaylineTools.setPolygonKml({ ...kml, ...params })
        saveFile = await DJIWaylineTools.setZipDoc(file)
      } else if (params.template_types[0] === '3') {
        kml = {
          payloadLensIndex: payloadList,
          imageFormat: DEVICE_CAMERA_DIR[videoValue],
          shootType: SHOOT_TYPE.TIME,
          autoFlightSpeed: 10,
          heightMode: WaylineMapType.EGM96,
          globalHeight: 100,
          GSD: 5,
          irGSD: 5,
          orthoLidarOverlapW: 70,
          margin: 0,
          finishAction: FINISH_ACTION_TYPE.GO_HOME,
          flyToWaylineMode: FLY_TO_WAYLINE_MODEL_TYPE.SAFELY,
          takeOffSecurityHeight: 20,
          distance: 0,
          duration: 0,
          author: userName.value,
        }
        if (assAirport) {
          const air = addWaylineRef.value.dockSnList.find(el => el.device_sn === assAirport)
          if (air) {
            kml.startPoint = {
              longitude: air.lon * 1,
              latitude: air.lat * 1,
              height: 0,
            }
          }
        }
        file = DJIWaylineTools.setPolyLineKml({ ...kml, ...params })
        saveFile = await DJIWaylineTools.setZipDoc(file)
      }
      console.log(params, 'params')
      // return
      saveLine(workspaceId, params).then(async () => {
        const formData = new FormData()
        formData.append('file', saveFile, params.name + '.kmz')
        formData.append('dept_ids', params.dept_ids)
        formData.append('inspection_area_id', params.inspection_area_id)
        addWaylineRef.value.handleCancle()
        const upload = await uploadReName(workspaceId, formData)
        console.info('航线文件已创建')
        localStorage.setItem('editWayline', JSON.stringify(upload.data.data))
        if (params.template_types[0] === '0' || params.template_types[0] === 0) {
          router.push({
            path: '/wayline-edit/' + upload.data.data.id,
          })
        } else if (params.template_types[0] === 1 || params.template_types[0] === 2 || params.template_types[0] === '1' || params.template_types[0] === '2') {
          router.push({
            path: '/wayline-edit-planar/' + upload.data.data.id,
          })
        } else if (params.template_types[0] === '3' || params.template_types[0] === 3) {
          router.push({
            path: '/wayline-edit-strip/' + upload.data.data.id,
          })
        }
      })
    })
    .catch((err) => {
      console.log('checkNameError', err)
      errorForm.nameOr = true
    })
}

const kmzDoc = async (params) => {
  const choseList = params.drone_model_key.split('-')
  const videoList = params.payload_model_keys[0].split('-')
  const config = {
    Document: {
      missionConfig: {
        droneInfo: {
          droneEnumValue: choseList[1],
          droneSubEnumValue: choseList[0],
        },
        payloadInfo: {
          payloadEnumValue: videoList[1],
          payloadSubEnumValue: videoList[2],
          payloadPositionIndex: videoList[0],
        },
      },
      Folder: {},
      waypoints: [],
    },
  }
  const kmlObject = DJIWaylineTools.generateStripRoute(config)
  const file = await DJIWaylineTools.setKmzDoc(kmlObject.templateInfo)
  // 生成KMZ文件
  return file
}

const activeFolderId = ref('')

const selectFolder = (folderId) => {
  if (activeFolderId.value === folderId) {
    activeFolderId.value = ''
  } else {
    activeFolderId.value = folderId
  }
  pagination.page = 1
  waylinesData.data = []
  getWaylines()
}

function getWaylines () {
  if (!canRefresh.value) {
    return
  }
  canRefresh.value = false

  // 构建请求参数
  const params: any = {
    page: pagination.page,
    page_size: pagination.page_size,
    order_by: 'update_time desc',
  }
  if (store.state.isFromCreatePlan) {
    params.executed = true
  }

  if (templateType.value && templateType.value.length > 0) {
    params.template_type = templateType.value.join(',')
  }

  // 如果选择了文件夹，则添加文件夹ID参数
  if (activeFolderId.value && activeFolderId.value !== '') {
    params.folder_id = activeFolderId.value
  }
  getWaylineFiles(workspaceId, params)
    .then((res) => {
      if (res.code !== 0) {
        return
      }
      waylinesData.data = [...waylinesData.data, ...res.data.list]

      // console.log('waylinesData.data', waylinesData.data)
      pagination.total = res.data.pagination.total
      pagination.page = res.data.pagination.page
    })
    .finally(() => {
      canRefresh.value = true
    })
}

function showWaylineTip (waylineId: string) {
  deleteWaylineId.value = waylineId
  deleteTip.value = true
}

function deleteWayline () {
  deleteWaylineFile(workspaceId, deleteWaylineId.value).then((res) => {
    if (res.code === 0) {
      message.success('航线文件已删除')
    }
    deleteWaylineId.value = ''
    deleteTip.value = false
    pagination.total = 0
    pagination.page = 1
    waylinesData.data = []
    if (store.state.waylineInfo.id === deleteWaylineId.value) {
      store.commit('SET_SELECT_WAYLINE_INFO', null)
      store.commit('SET_PLANAR_ALL_ROUTES', [])
      store.commit('SET_PLANAR_POLYGON', [])
      store.commit('SET_PLANAR_START_POINT', null)
      store.commit('SET_PLANAR_INDEX', 0)

      state.drawTool?.clearPointLine()
    }
    getWaylines()
  })
}

function downloadWayline (waylineId: string, fileName: string) {
  loading.value = true
  downloadWaylineFile(workspaceId, waylineId)
    .then((res) => {
      if (!res) {
        return
      }
      const data = new Blob([res], { type: 'application/zip' })
      downloadFile(data, fileName + '.kmz')
    })
    .finally(() => {
      loading.value = false
    })
}

function selectRoute (wayline: WaylineFile) {
  if (!auth.hasPermi(['wayline:current'])) return
  store.commit('SET_SELECT_WAYLINE_INFO', wayline)
}

function onScroll (e: any) {
  const element = e.srcElement
  if (
    element.scrollTop + element.clientHeight >= element.scrollHeight - 5 &&
    Math.ceil(pagination.total / pagination.page_size) > pagination.page &&
    canRefresh.value
  ) {
    pagination.page++
    getWaylines()
  }
}

interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: string;
  url?: string;
}

interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}
const fileList = ref<FileItem[]>([])

function beforeUpload (file: FileItem) {
  fileList.value = [file]
  loading.value = true
  return true
}
const uploadFile = async () => {
  fileList.value.forEach(async (file: FileItem) => {
    const fileData = new FormData()
    fileData.append('file', file, file.name)
    await importKmzFile(workspaceId, fileData)
      .then((res) => {
        if (res.code === 0) {
          message.success(`${file.name} file uploaded successfully`)
          canRefresh.value = true
          pagination.total = 0
          pagination.page = 1
          waylinesData.data = []
          getWaylines()
        }
      })
      .finally(() => {
        loading.value = false
        fileList.value = []
      })
  })
}

function handleEdit (row) {
  store.commit('SET_SELECT_WAYLINE_INFO', null)
  store.commit('SET_PLANAR_ALL_ROUTES', [])
  store.commit('SET_PLANAR_POLYGON', [])
  store.commit('SET_PLANAR_START_POINT', null)
  store.commit('SET_PLANAR_INDEX', 0)
  state.drawTool?.clearPointLine()
  localStorage.setItem('editWayline', JSON.stringify(row))
  if (row.template_types[0] === '0' || row.template_types[0] === 0) {
    router.push({
      path: '/wayline-edit/' + row.id,
    })
  } else if (row.template_types[0] === '1' || row.template_types[0] === 1 || row.template_types[0] === '2' || row.template_types[0] === 2) {
    router.push({
      path: '/wayline-edit-planar/' + row.id,
    })
  } else {
    router.push({
      path: '/wayline-edit-strip/' + row.id,
    })
  }
}

watch(
  () => store.state.waylineInfo,
  async (waylineInfo) => {
    if (waylineInfo && waylineInfo.id) {
      // 下载文件逻辑保持不变
      // 下载文件
      downloadWaylineFile(workspaceId, waylineInfo.id).then(async (res) => {
        if (
          waylineInfo.template_types[0] === '0' ||
          waylineInfo.template_types[0] === 0
        ) {
          drawWaylinePoint(res, state.drawTool)
        } else if (
          waylineInfo.template_types[0] === '1' ||
          waylineInfo.template_types[0] === 1 ||
          waylineInfo.template_types[0] === '2' ||
          waylineInfo.template_types[0] === 2
        ) {
          drawWaylinePolygon(res, state.drawTool)
        } else {
          drawWaylineStrip(res, state.drawTool)
        }
      })
    }
  },
)

// const waylineFolders = ref('')
const waylineFolders = ref<any[]>([])

const getFolderList = async () => {
  const res = await getWaylineFolderTree()
  waylineFolders.value = res.data
  console.log('文件夹列表:', waylineFolders.value)
}

/* const getFolderList = async () => {
  const param = {}
  const res = await getWaylineFolderList(param)
  waylineFolders.value = res.data
  console.log('文件夹列表:', waylineFolders.value)
} */

const showFolderInput = ref(false)
const newFolderName = ref('')
const inlineFolderInputRef = ref()
const editingFolderId = ref<string>('')
const deleteFolderTip = ref(false)
const deleteFolderId = ref<string>('')

const newFolder = ref('')

const showAddFolderInput = () => {
  showFolderInput.value = true
  newFolderName.value = ''
  editingFolderId.value = ''

  nextTick(() => {
    inlineFolderInputRef.value?.focus()
  })
}

const showAddNextFolderInput = (folder) => {
  newFolder.value = folder
  showFolderInput.value = true
  newFolderName.value = ''
  editingFolderId.value = ''
  nextTick(() => {
    inlineFolderInputRef.value?.focus()
  })
}

const editingFolderParentId = ref<string>('')

// 取消创建文件夹
const cancelCreateFolder = () => {
  showFolderInput.value = false
  newFolderName.value = ''
  editingFolderId.value = ''
  newFolder.value = ''
  editingFolderParentId.value = ''
}

// 编辑文件夹
const editWaylineFolder = (folder: any) => {
  if (!folder || !folder.id) {
    console.error('文件夹信息缺失')
    return
  }

  // 保存当前编辑的文件夹ID
  editingFolderId.value = folder.id
  editingFolderParentId.value = folder.parent_id || ''
  // 设置输入框的值为当前文件夹名称
  newFolderName.value = folder.name || ''

  // 使用 nextTick 确保 DOM 更新后输入框已渲染
  nextTick(() => {
    // 查找内联输入框并聚焦
    const inputElement = inlineFolderInputRef.value
    if (inputElement) {
      if (Array.isArray(inputElement) && inputElement.length > 0) {
        // ref 是数组的情况
        inputElement[0].focus()
        inputElement[0].select() // 可选：选中文本
      } else if (inputElement.focus) {
        // ref 是单个元素的情况
        inputElement.focus()
        inputElement.select() // 可选：选中文本
      }
    }
  })
}

const cancelEditFolder = () => {
  editingFolderId.value = ''
  newFolderName.value = ''
  editingFolderParentId.value = ''
}

// 添加文件夹函数
const createOrUpdateFolder = async () => {
  if (!newFolderName.value.trim()) {
    message.warning('请输入文件夹名称')
    // 聚焦回输入框（编辑状态不退出）
    nextTick(() => inlineFolderInputRef.value?.focus())
    return
  }
  try {
    const param: any = {
      name: newFolderName.value.trim(),
      workspace_id: workspaceId,
    }

    // 编辑模式：添加 id 和 parent_id
    if (editingFolderId.value) {
      param.id = editingFolderId.value
      if (editingFolderParentId.value) {
        param.parent_id = editingFolderParentId.value // 传递父级ID
      }
    } else {
      // 新建模式：如果是在某个文件夹下新建子文件夹，则传递 parent_id
      if (newFolder.value && newFolder.value.id) {
        param.parent_id = newFolder.value.id
      }
    }
    const res = await createWaylineFolder(param)
    if (res.code === 0) {
      message.success(
        editingFolderId.value ? '文件夹更新成功' : '文件夹创建成功',
      )
      await getFolderList()
      // 退出编辑状态
      showFolderInput.value = false
      editingFolderId.value = ''
      newFolderName.value = ''
    } else {
      message.error(
        res.message ||
          (editingFolderId.value ? '更新文件夹失败' : '创建文件夹失败'),
      )
      // 保留编辑状态，方便用户重新输入
      nextTick(() => inlineFolderInputRef.value?.focus())
    }
  } catch (error) {
    console.error('操作文件夹失败:', error)
    message.error('操作文件夹失败')
    nextTick(() => inlineFolderInputRef.value?.focus())
  }
}

const showDeleteFolderTip = (folderId: string) => {
  deleteFolderId.value = folderId
  deleteFolderTip.value = true
}

const confirmDeleteFolder = async () => {
  if (!deleteFolderId.value) {
    message.warning('文件夹信息缺失')
    return
  }

  try {
    const res = await deleteWaylineFolder(deleteFolderId.value)
    if (res.code === 0) {
      message.success('文件夹删除成功')
      await getFolderList()

      // 如果当前选中的是被删除的文件夹，则切换到"全部航线"
      if (activeFolderId.value === deleteFolderId.value) {
        activeFolderId.value = ''
        pagination.page = 1
        waylinesData.data = []
        getWaylines()
      }
    } else {
      message.error(res.message || '删除文件夹失败')
    }
  } catch (error) {
    console.error('删除文件夹失败:', error)
    message.error('删除文件夹失败')
  } finally {
    deleteFolderTip.value = false
    deleteFolderId.value = ''
  }
}

watch(showFolderInput, (newVal) => {
  if (newVal) {
    nextTick(() => {
      inlineFolderInputRef.value?.focus()
    })
  } else {
    editingFolderId.value = ''
    newFolderName.value = ''
  }
})

const activeAddChildFolderId = ref<string | null>(null)
const newChildFolderName = ref('')
const addChildLoading = ref(false)

const showAddChildInput = (folder: any) => {
  if (!folder || !folder.id) return
  activeAddChildFolderId.value = folder.id
  newChildFolderName.value = ''
  // 等待 DOM 更新后自动聚焦输入框
  nextTick(() => {
    const input = document.querySelector('.add-child-input input') as HTMLInputElement
    input?.focus()
  })
}

const cancelAddChild = () => {
  activeAddChildFolderId.value = null
  newChildFolderName.value = ''
}

const confirmAddChild = async () => {
  if (!newChildFolderName.value.trim()) {
    message.warning('请输入文件夹名称')
    return
  }
  if (!activeAddChildFolderId.value) return

  addChildLoading.value = true
  try {
    const param = {
      name: newChildFolderName.value.trim(),
      workspace_id: workspaceId,
      parent_id: activeAddChildFolderId.value, // 父文件夹 ID
    }
    const res = await createWaylineFolder(param)
    if (res.code === 0) {
      message.success('子文件夹创建成功')
      await getFolderList() // 刷新树
      cancelAddChild()
    } else {
      message.error(res.message || '创建失败')
    }
  } catch (error) {
    console.error('创建子文件夹失败', error)
    message.error('创建失败')
  } finally {
    addChildLoading.value = false
  }
}

const removeFileVisible = ref(false)
const selectedMoveFolderId = ref<string>('')
const currentMoveWaylineId = ref<string>('')

const moveTreeData = computed(() => treeData.value)

const moveExpandedKeys = ref<string[]>([])

const moveCheckedKeys = ref<string[]>([])

watch(selectedMoveFolderId, (newId) => {
  if (newId) {
    moveCheckedKeys.value = [newId]
  } else {
    moveCheckedKeys.value = []
  }
}, { immediate: true })

const onMoveCheck = (checkedKeys: any, info: any) => {
  // checkedKeys 可能是 { checked: [...], halfChecked: [...] } 或直接数组，取决于 checkStrictly
  let newChecked: string[] = []
  if (Array.isArray(checkedKeys)) {
    newChecked = checkedKeys
  } else if (checkedKeys.checked) {
    newChecked = checkedKeys.checked
  } else {
    newChecked = []
  }
  // 只保留最后一个选中的节点
  const lastKey = newChecked.length ? newChecked[newChecked.length - 1] : ''
  moveCheckedKeys.value = lastKey ? [lastKey] : []
  selectedMoveFolderId.value = lastKey
}

const showMoveModal = (waylineId: string) => {
  currentMoveWaylineId.value = waylineId
  removeFileVisible.value = true
  // 可选：默认展开所有节点
  moveExpandedKeys.value = getAllNodeKeys(treeData.value)
}

const getAllNodeKeys = (nodes: any[]): string[] => {
  let keys: string[] = []
  nodes.forEach(node => {
    keys.push(node.key)
    if (node.children && node.children.length) {
      keys = keys.concat(getAllNodeKeys(node.children))
    }
  })
  return keys
}

const cancelMove = () => {
  removeFileVisible.value = false
  selectedMoveFolderId.value = ''
  currentMoveWaylineId.value = ''
  moveCheckedKeys.value = []
}

// 确认移动
const confirmMove = async () => {
  if (!selectedMoveFolderId.value || !currentMoveWaylineId.value) {
    message.warning('请选择目标文件夹')
    return
  }

  try {
    const params = {
      folder_id: selectedMoveFolderId.value,
      wayline_ids: [currentMoveWaylineId.value],
    }
    const res = await getUpdateWaylineFolder(params)

    if (res.code === 0 || res.code === 200) {
      message.success('移动成功')
      pagination.page = 1
      waylinesData.data = []
      getWaylines()
      cancelMove()
    } else {
      message.error(res.message || '移动失败')
    }
  } catch (error) {
    console.error('移动失败:', error)
    message.error('移动失败')
  }
}

const addFileVisible = ref(false)
const addFileData = ref([])
const selectedRowKeys = ref<string[]>([])
const selectedRows = ref<any[]>([])
const addFileLoading = ref(false)
const currentAddFolderId = ref('')

const addFileColumns = [
  { title: '航线名称', width: 300, dataIndex: 'name', key: 'name' },
]

const rowSelection = computed(() => {
  return {
    type: 'checkbox', // 明确指定选择类型为多选
    selectedRowKeys: selectedRowKeys.value,
    onChange: (keys: string[], rows: any[]) => {
      console.log('选中的keys:', keys)
      console.log('选中的rows:', rows)
      selectedRowKeys.value = keys
      selectedRows.value = rows
    },
    getCheckboxProps: (record: any) => ({
      disabled: false,
      name: record.name,
    }),
  }
})

const openAddWaylineToFolder = (folderId: string) => {
  currentAddFolderId.value = folderId
  addFileVisible.value = true
  selectedRowKeys.value = []
  selectedRows.value = []
  getUnboundList()
}

const getUnboundList = async () => {
  const param = {}
  const res = await getUnboundWaylineFolderList(param)
  addFileData.value = res.data
  if (res.code === 0) {
    addFileData.value = res.data.map((item) => {
      if (!item.id) {
        return {
          ...item,
          id: item.id || Date.now() + Math.random(),
        }
      }
      return item
    })
  }
}

const cancelAddFile = () => {
  addFileVisible.value = false
  selectedRowKeys.value = []
  selectedRows.value = []
  currentAddFolderId.value = ''
  addFileLoading.value = false
}

const confirmAddFile = async () => {
  if (selectedRowKeys.value.length === 0) {
    message.warning('请选择要添加的航线')
    return
  }

  if (!currentAddFolderId.value) {
    message.error('文件夹信息缺失')
    return
  }

  try {
    addFileLoading.value = true

    const params = {
      folder_id: currentAddFolderId.value,
      wayline_ids: selectedRowKeys.value,
    }

    const res = await getUpdateWaylineFolder(params)

    if (res.code === 0) {
      message.success(
        `成功添加 ${selectedRowKeys.value.length} 条航线到文件夹`,
      )

      // 刷新当前文件夹的航线列表
      if (activeFolderId.value === currentAddFolderId.value) {
        pagination.page = 1
        waylinesData.data = []
        getWaylines()
      }

      // 关闭模态框并重置状态
      cancelAddFile()

      // 刷新未绑定列表（可选）
      // getUnboundList()
    } else {
      message.error(res.message || '添加航线到文件夹失败')
    }
  } catch (error) {
    console.error('添加航线到文件夹失败:', error)
    message.error('添加航线到文件夹失败')
  } finally {
    addFileLoading.value = false
  }
}

// 树展开的节点 key 数组
const expandedKeys = ref<string[]>([])

// 将 waylineFolders 转换为 a-tree 所需格式（添加 key）
const treeData = computed(() => {
  if (!Array.isArray(waylineFolders.value) || waylineFolders.value.length === 0) return []
  const addKey = (nodes: any[]): any[] => {
    return nodes.map(node => ({
      ...node,
      title: node.name,
      key: node.id, // a-tree 必须的 key
      children: node.children ? addKey(node.children) : [],
      scopedSlots: { title: 'title' },
    }))
  }
  return addKey(waylineFolders.value)
})

// 处理树节点选中（避免与内部按钮事件冲突）
const handleTreeSelect = (selectedKeys: string[], info: any) => {
  if (selectedKeys.length > 0) {
    selectFolder(selectedKeys[0])
  }
}

// 新增部门选择相关状态
const uploadWaylineVisible = ref(false)
const uploadLoading = ref(false)
const uploadFileName = ref('')
const showDeptPanel = ref(false)
const deptTreeData = ref<any[]>([]) // 部门树数据
const selectedDeptKeys = ref<string[]>([]) // 选中的部门ID数组
const selectedDeptNames = ref<string[]>([]) // 选中的部门名称数组
const expandedDeptKeys = ref<string[]>([]) // 树展开的节点
const selectedFile = ref<File | null>(null)

const selectedDeptNamesStr = computed({
  get: () => selectedDeptNames.value.join('、'),
  set: () => {}
})

const fetchDeptTree = async () => {
  try {
    const res = await getDeptList()
    if (res.code === 200 && res.data) {
      deptTreeData.value = buildTreeData(res.data)
      if (deptTreeData.value.length) {
        expandedDeptKeys.value = deptTreeData.value.map(node => node.key)
      }
    }
  } catch (error) {
    console.error('获取部门列表失败', error)
  }
}

// 将部门数据转换为 antd tree 所需格式
const buildTreeData = (nodes: any[], isRoot: boolean = true): any[] => {
  if (!nodes || !nodes.length) return []
  return nodes.map(node => ({
    title: node.label,
    key: node.id,
    disableCheckbox: isRoot, // 根节点禁用复选框，子节点可勾选
    children: node.children ? buildTreeData(node.children, false) : []
  }))
}

// 树节点勾选事件（checkStrictly 模式下，checkedKeys 直接是数组）
const onDeptCheck = (checkedKeys: any, info: any) => {
  // checkStrictly 模式下，checkedKeys 就是选中节点的 key 数组
  const keys: string[] = Array.isArray(checkedKeys) ? checkedKeys : checkedKeys.checked || []
  selectedDeptKeys.value = keys

  // 收集选中的部门名称（根据 keys 从树数据中查找）
  const names: string[] = []
  const collectNames = (nodes: any[]) => {
    nodes.forEach(node => {
      if (keys.includes(node.key)) {
        names.push(node.title)
      }
      if (node.children) collectNames(node.children)
    })
  }
  collectNames(deptTreeData.value)
  selectedDeptNames.value = names
}

// 关闭模态框时重置状态
const closeUploadModal = () => {
  uploadWaylineVisible.value = false
  uploadFileName.value = ''
  selectedFile.value = null
  selectedDeptKeys.value = []
  selectedDeptNames.value = []
  showDeptPanel.value = false
  flightAreaValue.value = null
}

const handleFileChange = (info: any) => {
  const file = info.file
  if (file) {
    const originFile = file.originFileObj || file
    selectedFile.value = originFile
    uploadFileName.value = originFile.name
  }
}

const doUploadWaylineVisible = async () => {
  if (!selectedFile.value) {
    message.warning('请先选择文件')
    return
  }

  const formData = new FormData()
  formData.append('file', selectedFile.value)

  if (selectedDeptKeys.value.length) {
    formData.append('dept_ids', selectedDeptKeys.value.join(','))
  }
  formData.append('inspection_area_id', flightAreaValue.value)

  try {
    uploadLoading.value = true
    const res = await importKmzFile(workspaceId, formData)
    if (res.code === 0) {
      message.success(`${selectedFile.value!.name} 上传成功`)
      pagination.page = 1
      waylinesData.data = []
      getWaylines()
      closeUploadModal()
    } else {
      message.error(res.message || '上传失败')
    }
  } catch (error) {
    message.error('上传失败，请重试')
  } finally {
    uploadLoading.value = false
  }
}

const openuploadWaylineVisible = () => {
  uploadWaylineVisible.value = true
  fetchDeptTree()
}

// 巡检区域
const flightData = ref([])

const flightAreaValue = ref(null)

const convertToTreeData = (items: any[]): any[] => {
  return items.map(item => ({
    key: item.id,
    title: item.name,
    value: item.id,
    children: item.hasChildren && item.children ? convertToTreeData(item.children) : undefined,
    isLeaf: !item.hasChildren
  }))
}

const flightAreaTreeData = computed(() => convertToTreeData(flightData.value))

const fetchFlightAreaData = async () => {
  const res = await getCheckInspectionAreasList()
  flightData.value = res.data
}

onMounted(async () => {
  await nextTick()
  viewer.value = getCesiumMap()
  mapDataSource.value = getCesiumDataSource()

  getWaylines()
  getFolderList()
  fetchFlightAreaData()

  const key = setInterval(() => {
    const data = document.getElementById('data')
      ?.lastElementChild as HTMLDivElement
    if (
      pagination.total === 0 ||
      Math.ceil(pagination.total / pagination.page_size) <= pagination.page ||
      listHeight.value <= data?.clientHeight + data?.offsetTop
    ) {
      clearInterval(key)
      return
    }
    pagination.page++
    getWaylines()
  }, 1000)

  waylineAttList()
})

onUnmounted(() => {
  if (state.drawTool) {
    state.drawTool?.clearPointLine()
  }
})
</script>

<style lang="scss" scoped>
.project-wayline-wrapper {
  height: 100%;
  position: relative;
}

.way-head {
  border-bottom: 1px solid #4f4f4f;
  font-weight: 450;
  background: #2f2f2f;
  position: relative;
  z-index: 1;
}

// 主要内容容器
.wayline-content-container {
  height: calc(100% - 100px); // 减去头部高度
  position: relative;
  width: 100%;
}

// 文件夹列表容器 - 使用绝对定位
.folder-list-container {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 220px;
  background: #2a2a2a;
  border-right: 1px solid #4f4f4f;
  z-index: 1;
}

// 文件夹列表
.folder-list {
  height: 100%;
  display: flex;
  flex-direction: column;

  .folder-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 10px;
    font-weight: 500;
    border-bottom: 1px solid #4f4f4f;
    color: hsla(0, 0%, 100%, 0.85);
    font-size: 14px;
    flex-shrink: 0;
  }

  .add-folder {
    font-size: 20px;
    // margin-left: 48%;
    cursor: pointer;
  }

  .folder-input-container {
    padding: 10px;
    border-bottom: 1px solid #4f4f4f;
    background-color: #3c3c3c;
  }

  .folder-input {
    width: 75%;
    background-color: #2a2a2a;
    border: 1px solid #4f4f4f;
    color: hsla(0, 0%, 100%, 0.85);

    &:focus {
      border-color: #1890ff;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }

    &::placeholder {
      color: hsla(0, 0%, 100%, 0.45);
    }
  }

  .folder-content {
    flex: 1;
    height: 90%;
    padding: 8px 0;
  }

  .folder-item {
    padding: 10px 16px;
    cursor: pointer;
    color: hsla(0, 0%, 100%, 0.65);
    display: flex;
    align-items: center;
    justify-content: space-between; // 关键：让左右两端对齐
    font-size: 13px;
    transition: all 0.3s;

    &:hover {
      background-color: #3c3c3c;
      color: hsla(0, 0%, 100%, 0.85);

      .folder-add-icon {
        opacity: 1;
      }
    }

    &.folder-active {
      background-color: #4da9f5;
      color: white;

      &:hover {
        background-color: #4da9f5;
      }
    }
  }

  .folder-item-left {
    display: flex;
    align-items: center;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  // 右侧添加图标
  .folder-add-icon {
    margin-left: 8px;
    flex-shrink: 0;
    opacity: 0.6;
    transition: opacity 0.3s;
    font-size: 14px;

    &:hover {
      opacity: 1;
      color: #1890ff;
    }
  }

  // 确保空状态不受影响
  .empty-folder {
    text-align: center;
    color: hsla(0, 0%, 100%, 0.45);
  }
}

// 航线列表容器 - 使用绝对定位，从文件夹列表右侧开始
.wayline-list-container {
  position: absolute;
  left: 220px; // 文件夹列表宽度
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  background: #2f2f2f;

  #data {
    height: 100%;
    overflow: auto;
    // padding: 0 10px;
  }
}

.wayline-panel {
  background: #3c3c3c;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  height: 120px;
  width: 100%;
  font-size: 13px;
  border-radius: 2px;
  cursor: pointer;

  .title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 30px;
    font-weight: bold;
    margin: 0px 10px 0 10px;
  }
}

.uranus-scrollbar {
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: #c5c8cc transparent;
}

.ant-spin-container {
  height: 100%;
}

.wayline-file {
  width: 60%;
}

// .add {
//   width: 30%;
// }

.select-header {
  margin: 10px 0px 10px 10px;
}
.wayline-icon-list {
  display: flex;
  align-items: center;
  margin-top: 5px;
  .wayline-icon-item {
    padding: 3px;
    background-color: #3c3c3c;
    cursor: pointer;
    &.active {
      background-color: #4da9f5;
    }
    &:not(&.active){
    &:hover {
      background-color: #797878;
    }
  }
    & + .wayline-icon-item {
      margin-left: 10px;
    }
  }
}
.select-type {
  width: 30%;
}

.addModal {
  margin-bottom: 20px;
  font-size: 15px;
}

.sel {
  margin-top: 5px;
  width: 100%;
}

.chose {
  width: 195px;
}

.ant-btn-true {
  color: #40a9ff;
  border-color: #40a9ff;
}

.form-tips {
  color: red;
  font-size: 12px;
}

.flex-row {
  display: inline-flex;
}

.way-name {
  width: 120px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.way-user {
  width: 80px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.way-down {
  background: #3c3c3c;
}

.way-color {
  color: hsla(0, 0%, 100%, 0.65);
}

.cam-icon {
  border-top: 1px solid;
  padding-top: -3px;
}

.way-color1 {
  color: hsla(0, 0%, 100%, 0.35);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.wayline-container {
  display: block;
  height: auto;
}

.folder-modal-container {
  max-height: 400px;
  overflow-y: auto;
}

.folder-modal-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 4px 0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid transparent;

  &:hover {
    background-color: rgba(24, 144, 255, 0.1);
    border-color: rgba(24, 144, 255, 0.3);
  }

  &.folder-modal-selected {
    background-color: rgba(24, 144, 255, 0.15);
    border-color: #1890ff;
  }

  .folder-info {
    display: flex;
    align-items: center;
    flex: 1;

    .folder-name {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .folder-count {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    margin-left: 16px;
    flex-shrink: 0;
  }
}

.folder-divider {
  height: 1px;
  background-color: #f0f0f0;
  margin: 12px 0;
}

.folder-list-modal {
  .folder-modal-item {
    padding: 10px 16px;
  }
}

.folder-empty-modal {
  padding: 40px 0;
  text-align: center;
}

// 模态框底部按钮
.folder-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
  margin-top: 20px;

  .modal-cancel-btn {
    min-width: 80px;
  }

  .modal-confirm-btn {
    min-width: 80px;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}

</style>

<style lang="scss">
.folder-tree {
  background-color: #2f2f2f;
  background: transparent !important;
  color: hsla(0, 0%, 100%, 0.65);

  // 1. 强制所有内部容器背景透明
  .ant-tree,
  .ant-tree-list,
  .ant-tree-list-holder,
  .ant-tree-list-holder-inner {
    background: transparent !important;
  }

  // 2. 节点行样式（去除默认 padding，防止内容溢出）
  .ant-tree-treenode {
    padding: 0 !important;
    margin: 0 !important;
    width: 100%;
    overflow: hidden;
    &:hover,
    &.ant-tree-treenode-hover,
    &.ant-tree-treenode-selected {
      background: transparent !important;
    }
  }

  // 3. 内容包裹层
  .ant-tree-node-content-wrapper {
    padding: 0 !important;
    margin: 0 !important;
    flex: 1;
    min-height: auto !important;
    &:focus,
    &:hover {
      background: transparent !important;
      outline: none;
    }
    &.ant-tree-node-content-wrapper-open,
    &.ant-tree-node-content-wrapper-close {
      background: transparent !important;
    }
  }

  // 4. 标题区域占满宽度
  .ant-tree-title {
    width: 100%;
    display: block;
  }

  // 5. 展开/收起箭头
  .ant-tree-switcher {
    color: hsla(0, 0%, 100%, 0.45);
    width: 18px;
    min-width: 18px;
    line-height: 36px;
    flex-shrink: 0;
    &:hover {
      color: hsla(0, 0%, 100%, 0.85);
    }
    .ant-tree-switcher-icon svg {
      fill: currentColor;
    }
  }

  // 6. 解决缩进样式问题（全局样式无需 :deep，直接写即可生效）
  .ant-tree-indent-unit {
    width: 15px !important;
  }
  /* .ant-tree-indent {
    width: 10px !important;
  } */

  // ================= 以下为自定义文件夹项样式（适配 220px 宽度） =================

  .folder-item {
    padding: 8px 8px;
    margin-left: 0;
    width: 100%;
    background-color: #2f2f2f;
    border-radius: 0;
    transition: all 0.2s;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    cursor: pointer;
    color: hsla(0, 0%, 100%, 0.65);
    position: relative;

    .folder-badge {
      position: absolute;
      top: 0;
      left: 0;
      transform: translate(30%, -30%);  /* 徽章默认有圆角，可稍微外移 */
      z-index: 1;
    }

    &:hover {
      background-color: #4a4a4a;
      color: hsla(0, 0%, 100%, 0.85);
      .folder-add-icon {
        opacity: 1;
      }
    }
    &.folder-active {
      background-color: #4da9f5;
      color: white;
      &:hover {
        background-color: #4da9f5;
      }
    }
  }

  .folder-item-left {
    display: flex;
    align-items: center;
    flex: 1;
    gap: 4px;
    overflow: hidden;
    min-width: 0; // 允许 flex 子元素收缩
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .folder-actions {
    display: flex;
    gap: 4px;
    align-items: center;
    flex-shrink: 0;
    .folder-add-icon {
      margin-left: 0;
      opacity: 0.6;
      font-size: 14px;
      cursor: pointer;
      &:hover {
        opacity: 1;
        color: #1890ff;
      }
    }
  }

  .inline-folder-input {
    width: 90px;
    background-color: #2a2a2a;
    border: 1px solid #4f4f4f;
    color: hsla(0, 0%, 100%, 0.85);
    &:focus {
      border-color: #1890ff;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }
  }

  .folder-name-text {
    color: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 90px;
  }
}

.add-child-input {
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: #2F2F2F;
  border-radius: 4px;
  margin-left: -30px;
  padding-left: 15px;
}

// 部门选择面板样式
.dept-selector {
  display: flex;
  align-items: center;
  position: relative;
}

.dept-panel {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  margin-top: 4px;
  background: #FFFFFF;
  border: 1px solid #e6e4e4;
  border-radius: 6px;
  box-shadow: 0 3px 6px -4px rgba(255, 251, 251, 0.48);
  background-color: #FFFFFF;
  // color: rgba(255, 255, 255, 0.85);

  .dept-panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 12px;
    border-bottom: 1px solid #4f4f4f;
    font-weight: 500;

    span:first-child {
      font-size: 14px;
    }

    .anticon-close {
      cursor: pointer;
      font-size: 14px;
      &:hover {
        color: #1890ff;
      }
    }
  }

  .dept-tree-container {
    max-height: 300px;
    overflow-y: auto;
    padding: 8px 12px;
  }
}
</style>
